import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Product {
  id_product: number;
  name: string;
  price_sell: string;
  price_bought: string;
  stock: number;
  photo?: string;
  barcode?: string | number;
  typeOfQuantity?: string;
  Userid?: number;
}

interface StockState {
  products: Product[];
  isLoading: boolean;
  lastFetch: number | null;
  error: string | null;
}

const initialState: StockState = {
  products: [],
  isLoading: false,
  lastFetch: null,
  error: null,
};

const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setProducts: (state, action: PayloadAction<Product[]>) => {
      state.products = action.payload;
      state.lastFetch = Date.now();
      state.error = null;
    },
    addProduct: (state, action: PayloadAction<Product>) => {
      state.products.push(action.payload);
    },
    updateProduct: (state, action: PayloadAction<Product>) => {
      const index = state.products.findIndex(
        (product) => product.id_product === action.payload.id_product
      );
      if (index !== -1) {
        state.products[index] = action.payload;
      }
    },
    removeProduct: (state, action: PayloadAction<number>) => {
      state.products = state.products.filter(
        (product) => product.id_product !== action.payload
      );
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    // Force reset loading state - useful for debugging stuck loading
    forceResetLoading: (state) => {
      state.isLoading = false;
    },
    // Utility function to search products locally
    searchProducts: (state, action: PayloadAction<string>) => {
      // This reducer doesn't modify state, it's just for type safety
      // The actual search will be done in selectors
    },
  },
});

export const stockActions = stockSlice.actions;
export const stockReducer = stockSlice.reducer;
export type { Product };
